import type { DemoScript } from "../types.js";

/**
 * Onboarding basics: drag a task block to another day, then complete it.
 * Uses the 4-day view anchored on today so `today+1` is ALWAYS on screen
 * (in week view a demo running on the week's last day would drag off-grid).
 */
export const basicsReschedule: DemoScript = {
  id: "basics-reschedule",
  titleKey: "demos.title.basicsReschedule",
  view: { kind: "days", count: 4 },
  stage: { width: 960, height: 600 },
  fixture: [
    { ref: "standup", titleKey: "demos.fx.standup", dayOffset: 0, hour: 9, durationMin: 30, isEvent: true },
    { ref: "report", titleKey: "demos.fx.writeReport", dayOffset: 0, hour: 15, durationMin: 60 },
    { ref: "design", titleKey: "demos.fx.designReview", dayOffset: 1, hour: 11, durationMin: 60, isEvent: true },
    { ref: "lunch", titleKey: "demos.fx.lunch", dayOffset: 1, hour: 12, minute: 30, durationMin: 45, isEvent: true },
    { ref: "gym", titleKey: "demos.fx.gym", dayOffset: 2, hour: 18, durationMin: 60, isEvent: true },
  ],
  steps: [
    { kind: "caption", key: "demos.cap.reschedule.intro" },
    { kind: "moveTo", target: { kind: "task", ref: "report" } },
    { kind: "press" },
    { kind: "dragTo", target: { kind: "dayColumn", dayOffset: 1, hour: 14 }, captionKey: "demos.cap.reschedule.drag" },
    { kind: "release" },
    {
      kind: "action",
      run: (ctx) => ctx.stores.tasks.reschedule(ctx.id("report"), ctx.at(1, 14)),
      captionKey: "demos.cap.reschedule.moved",
    },
    { kind: "pause", ms: 500 },
    { kind: "moveTo", target: { kind: "task", ref: "report" } },
    { kind: "press" },
    { kind: "release" },
    {
      kind: "action",
      run: (ctx) => ctx.stores.tasks.complete(ctx.id("report"), true),
      captionKey: "demos.cap.reschedule.complete",
    },
    { kind: "pause", ms: 800 },
  ],
};
